import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const My = lazy(() => import('@/pages/my'));
const MyProfile = lazy(() => import('@/pages/my/profile/Profile'));

export const myRoutes: TypedRouteObject = {
	path: ROOTS.MY,
	element: withSuspense(My),
	handle: {
		title: '내 정보 관리',
		subTitle: '락앤런 운영자 프로필 관리',
	},
	children: [
		{
			index: true,
			element: <Navigate to="profile" replace={true} />
		},
		{
			path: paths.my.profile.path,
			element: withSuspense(MyProfile),
			handle: {
				isGoBack: true,
				title: '내 프로필',
				subTitle: '관리자 계정 프로필 정보'
			}
		}
	]
}
